// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/utility-pattern.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 16%27%3e%3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M4 8h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.4 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden] {
  display: none;
}

[type='text'],input:where(:not([type])),[type='email'],[type='url'],[type='password'],[type='number'],[type='date'],[type='datetime-local'],[type='month'],[type='search'],[type='tel'],[type='time'],[type='week'],[multiple],textarea,select{
  appearance: none;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 #0000;
}

[type='text']:focus, input:where(:not([type])):focus, [type='email']:focus, [type='url']:focus, [type='password']:focus, [type='number']:focus, [type='date']:focus, [type='datetime-local']:focus, [type='month']:focus, [type='search']:focus, [type='tel']:focus, [type='time']:focus, [type='week']:focus, [multiple]:focus, textarea:focus, select:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #2563eb;
}

input::placeholder,textarea::placeholder{
  color: #6b7280;
  opacity: 1;
}

::-webkit-datetime-edit-fields-wrapper{
  padding: 0;
}

::-webkit-date-and-time-value{
  min-height: 1.5em;
  text-align: inherit;
}

::-webkit-datetime-edit{
  display: inline-flex;
}

::-webkit-datetime-edit,::-webkit-datetime-edit-year-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute-field,::-webkit-datetime-edit-second-field,::-webkit-datetime-edit-millisecond-field,::-webkit-datetime-edit-meridiem-field{
  padding-top: 0;
  padding-bottom: 0;
}

select{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

[multiple],[size]:where(select:not([size="1"])){
  background-image: initial;
  background-position: initial;
  background-repeat: unset;
  background-size: initial;
  padding-right: 0.75rem;
  -webkit-print-color-adjust: unset;
          print-color-adjust: unset;
}

[type='checkbox'],[type='radio']{
  appearance: none;
  padding: 0;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
          user-select: none;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: #2563eb;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  --tw-shadow: 0 0 #0000;
}

[type='checkbox']{
  border-radius: 0px;
}

[type='radio']{
  border-radius: 100%;
}

[type='checkbox']:focus,[type='radio']:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}

[type='checkbox']:checked,[type='radio']:checked{
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

[type='checkbox']:checked{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@media (forced-colors: active) {

  [type='checkbox']:checked{
    appearance: auto;
  }
}

[type='radio']:checked{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@media (forced-colors: active) {

  [type='radio']:checked{
    appearance: auto;
  }
}

[type='checkbox']:checked:hover,[type='checkbox']:checked:focus,[type='radio']:checked:hover,[type='radio']:checked:focus{
  border-color: transparent;
  background-color: currentColor;
}

[type='checkbox']:indeterminate{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

@media (forced-colors: active) {

  [type='checkbox']:indeterminate{
    appearance: auto;
  }
}

[type='checkbox']:indeterminate:hover,[type='checkbox']:indeterminate:focus{
  border-color: transparent;
  background-color: currentColor;
}

[type='file']{
  background: unset;
  border-color: inherit;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-size: unset;
  line-height: inherit;
}

[type='file']:focus{
  outline: 1px solid ButtonText;
  outline: 1px auto -webkit-focus-ring-color;
}

*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.container{
  width: 100%;
}
@media (min-width: 640px){

  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){

  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){

  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1260px){

  .container{
    max-width: 1260px;
  }
}
@media (min-width: 1280px){

  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){

  .container{
    max-width: 1536px;
  }
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.visible{
  visibility: visible;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.-bottom-6{
  bottom: -1.5rem;
}
.-left-28{
  left: -7rem;
}
.-right-full{
  right: -100%;
}
.-top-10{
  top: -2.5rem;
}
.-top-5{
  top: -1.25rem;
}
.-top-\\[0\\.5rem\\]{
  top: -0.5rem;
}
.-top-\\[1rem\\]{
  top: -1rem;
}
.-top-\\[3\\.5rem\\]{
  top: -3.5rem;
}
.bottom-0{
  bottom: 0px;
}
.end-0{
  inset-inline-end: 0px;
}
.left-0{
  left: 0px;
}
.left-\\[8\\%\\]{
  left: 8%;
}
.right-0{
  right: 0px;
}
.right-2{
  right: 0.5rem;
}
.right-4{
  right: 1rem;
}
.right-6{
  right: 1.5rem;
}
.right-\\[1\\%\\]{
  right: 1%;
}
.right-\\[8\\%\\]{
  right: 8%;
}
.start-0{
  inset-inline-start: 0px;
}
.start-1\\/10{
  inset-inline-start: 10%;
}
.start-2\\/10{
  inset-inline-start: 20%;
}
.start-3\\/10{
  inset-inline-start: 30%;
}
.start-4\\/10{
  inset-inline-start: 40%;
}
.start-5\\/10{
  inset-inline-start: 50%;
}
.start-6\\/10{
  inset-inline-start: 60%;
}
.start-7\\/10{
  inset-inline-start: 70%;
}
.start-8\\/10{
  inset-inline-start: 80%;
}
.top-0{
  top: 0px;
}
.top-10{
  top: 2.5rem;
}
.top-12{
  top: 3rem;
}
.top-14{
  top: 3.5rem;
}
.top-16{
  top: 4rem;
}
.top-2{
  top: 0.5rem;
}
.top-\\[14\\%\\]{
  top: 14%;
}
.z-10{
  z-index: 10;
}
.z-2{
  z-index: 2;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-50{
  z-index: 50;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[10\\]{
  z-index: 10;
}
.z-\\[15\\]{
  z-index: 15;
}
.z-\\[1\\]{
  z-index: 1;
}
.z-\\[20\\]{
  z-index: 20;
}
.z-\\[4\\]{
  z-index: 4;
}
.z-\\[5\\]{
  z-index: 5;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-span-3{
  grid-column: span 3 / span 3;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-10{
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-8{
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.-mb-\\[1\\%\\]{
  margin-bottom: -1%;
}
.-mr-1{
  margin-right: -0.25rem;
}
.mb-0{
  margin-bottom: 0px;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-20{
  margin-bottom: 5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-48{
  margin-bottom: 12rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-10{
  margin-left: 2.5rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-4{
  margin-right: 1rem;
}
.mr-auto{
  margin-right: auto;
}
.mt-0{
  margin-top: 0px;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-14{
  margin-top: 3.5rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-20{
  margin-top: 5rem;
}
.mt-28{
  margin-top: 7rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-40{
  margin-top: 10rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-\\[2rem\\]{
  margin-top: 2rem;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-24{
  height: 6rem;
}
.h-3{
  height: 0.75rem;
}
.h-4{
  height: 1rem;
}
.h-6{
  height: 1.5rem;
}
.h-8{
  height: 2rem;
}
.h-\\[0\\.25rem\\]{
  height: 0.25rem;
}
.h-\\[100vh\\]{
  height: 100vh;
}
.h-\\[15rem\\]{
  height: 15rem;
}
.h-\\[2\\.5rem\\]{
  height: 2.5rem;
}
.h-\\[200px\\]{
  height: 200px;
}
.h-\\[20rem\\]{
  height: 20rem;
}
.h-\\[2rem\\]{
  height: 2rem;
}
.h-\\[30rem\\]{
  height: 30rem;
}
.h-\\[35vh\\]{
  height: 35vh;
}
.h-\\[3rem\\]{
  height: 3rem;
}
.h-\\[400px\\]{
  height: 400px;
}
.h-\\[40vh\\]{
  height: 40vh;
}
.h-\\[4rem\\]{
  height: 4rem;
}
.h-\\[50rem\\]{
  height: 50rem;
}
.h-\\[6rem\\]{
  height: 6rem;
}
.h-\\[8\\.4375rem\\]{
  height: 8.4375rem;
}
.h-\\[80\\%\\]{
  height: 80%;
}
.h-\\[80vh\\]{
  height: 80vh;
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.h-screen{
  height: 100vh;
}
.max-h-\\[20rem\\]{
  max-height: 20rem;
}
.max-h-\\[40vh\\]{
  max-height: 40vh;
}
.max-h-\\[80vh\\]{
  max-height: 80vh;
}
.max-h-\\[85vh\\]{
  max-height: 85vh;
}
.min-h-\\[100vh\\]{
  min-height: 100vh;
}
.min-h-\\[20rem\\]{
  min-height: 20rem;
}
.min-h-\\[30vh\\]{
  min-height: 30vh;
}
.min-h-\\[400px\\]{
  min-height: 400px;
}
.min-h-\\[40rem\\]{
  min-height: 40rem;
}
.min-h-\\[50vh\\]{
  min-height: 50vh;
}
.w-1{
  width: 0.25rem;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-1\\/2{
  width: 50%;
}
.w-1\\/3{
  width: 33.333333%;
}
.w-2\\/3{
  width: 66.666667%;
}
.w-3{
  width: 0.75rem;
}
.w-4{
  width: 1rem;
}
.w-4\\/5{
  width: 80%;
}
.w-40{
  width: 10rem;
}
.w-6{
  width: 1.5rem;
}
.w-8{
  width: 2rem;
}
.w-\\[100\\%\\]{
  width: 100%;
}
.w-\\[100vw\\]{
  width: 100vw;
}
.w-\\[10rem\\]{
  width: 10rem;
}
.w-\\[12rem\\]{
  width: 12rem;
}
.w-\\[15rem\\]{
  width: 15rem;
}
.w-\\[1rem\\]{
  width: 1rem;
}
.w-\\[20rem\\]{
  width: 20rem;
}
.w-\\[30\\%\\]{
  width: 30%;
}
.w-\\[34\\%\\]{
  width: 34%;
}
.w-\\[40rem\\]{
  width: 40rem;
}
.w-\\[40vw\\]{
  width: 40vw;
}
.w-\\[4rem\\]{
  width: 4rem;
}
.w-\\[50rem\\]{
  width: 50rem;
}
.w-\\[50vw\\]{
  width: 50vw;
}
.w-\\[5rem\\]{
  width: 5rem;
}
.w-\\[80\\%\\]{
  width: 80%;
}
.w-\\[80vw\\]{
  width: 80vw;
}
.w-\\[90\\%\\]{
  width: 90%;
}
.w-auto{
  width: auto;
}
.w-extraLarge{
  width: 34rem;
}
.w-full{
  width: 100%;
}
.w-screen{
  width: 100vw;
}
.min-w-\\[100\\%\\]{
  min-width: 100%;
}
.min-w-\\[30vw\\]{
  min-width: 30vw;
}
.min-w-\\[5rem\\]{
  min-width: 5rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-\\[100\\%\\]{
  max-width: 100%;
}
.max-w-\\[100vw\\]{
  max-width: 100vw;
}
.max-w-\\[10rem\\]{
  max-width: 10rem;
}
.max-w-\\[300px\\]{
  max-width: 300px;
}
.max-w-\\[500px\\]{
  max-width: 500px;
}
.max-w-\\[60\\%\\]{
  max-width: 60%;
}
.max-w-\\[70\\%\\]{
  max-width: 70%;
}
.max-w-\\[80\\%\\]{
  max-width: 80%;
}
.max-w-\\[90\\%\\]{
  max-width: 90%;
}
.max-w-\\[95\\%\\]{
  max-width: 95%;
}
.max-w-full{
  max-width: 100%;
}
.flex-none{
  flex: none;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink-0{
  flex-shrink: 0;
}
.grow{
  flex-grow: 1;
}
.scale-0{
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes fade{

  0%{
    opacity: 0;
  }

  100%{
    opacity: 1;
    transform: scale(1);
  }
}
.animate-fade-in{
  animation: fade 0.5s cubic-bezier(0.4, 0, 0.6, 1) forwards;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-pointer{
  cursor: pointer;
}
.list-disc{
  list-style-type: disc;
}
.appearance-none{
  appearance: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-rows-\\[0fr\\]{
  grid-template-rows: 0fr;
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.flex-nowrap{
  flex-wrap: nowrap;
}
.place-content-center{
  place-content: center;
}
.items-start{
  align-items: flex-start;
}
.items-center{
  align-items: center;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-1{
  gap: 0.25rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-12{
  gap: 3rem;
}
.gap-14{
  gap: 3.5rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-24{
  gap: 6rem;
}
.gap-28{
  gap: 7rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-8{
  gap: 2rem;
}
.gap-\\[1rem\\]{
  gap: 1rem;
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.self-start{
  align-self: flex-start;
}
.self-center{
  align-self: center;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-y-scroll{
  overflow-y: scroll;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-line{
  white-space: pre-line;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-1\\/2{
  border-radius: 50%;
}
.rounded-\\[20px\\]{
  border-radius: 20px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-sm{
  border-radius: 0.125rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.border{
  border-width: 1px;
}
.border-2{
  border-width: 2px;
}
.border-4{
  border-width: 4px;
}
.border-\\[4px\\]{
  border-width: 4px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-l-2{
  border-left-width: 2px;
}
.border-l-4{
  border-left-width: 4px;
}
.border-r-2{
  border-right-width: 2px;
}
.border-t-2{
  border-top-width: 2px;
}
.border-t-4{
  border-top-width: 4px;
}
.border-\\[\\#000\\]{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-\\[\\#c4c4c4\\]{
  --tw-border-opacity: 1;
  border-color: rgb(196 196 196 / var(--tw-border-opacity));
}
.border-\\[\\#fff\\]{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-black{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-blue-500{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity));
}
.border-blue-600{
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity));
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-gray-700{
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity));
}
.border-green-400{
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity));
}
.border-primary{
  --tw-border-opacity: 1;
  border-color: rgb(0 141 218 / var(--tw-border-opacity));
}
.border-b-black{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-r-slate-900{
  --tw-border-opacity: 1;
  border-right-color: rgb(15 23 42 / var(--tw-border-opacity));
}
.border-opacity-25{
  --tw-border-opacity: 0.25;
}
.border-opacity-50{
  --tw-border-opacity: 0.5;
}
.bg-\\[\\#000\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-\\[\\#0A1172\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(10 17 114 / var(--tw-bg-opacity));
}
.bg-\\[\\#C0C0B0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(192 192 176 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFFFE0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 224 / var(--tw-bg-opacity));
}
.bg-\\[\\#a0cff5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(160 207 245 / var(--tw-bg-opacity));
}
.bg-\\[\\#c4c4c4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(196 196 196 / var(--tw-bg-opacity));
}
.bg-\\[\\#d4d4d4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 212 / var(--tw-bg-opacity));
}
.bg-\\[\\#fff\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity));
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity));
}
.bg-emerald-100{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity));
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-gray-900{
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity));
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity));
}
.bg-orange-300{
  --tw-bg-opacity: 1;
  background-color: rgb(253 186 116 / var(--tw-bg-opacity));
}
.bg-primary{
  --tw-bg-opacity: 1;
  background-color: rgb(0 141 218 / var(--tw-bg-opacity));
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}
.bg-slate-200{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity));
}
.bg-slate-300{
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity));
}
.bg-slate-50{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity));
}
.bg-transparent{
  background-color: transparent;
}
.bg-violet-300{
  --tw-bg-opacity: 1;
  background-color: rgb(196 181 253 / var(--tw-bg-opacity));
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-opacity-50{
  --tw-bg-opacity: 0.5;
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-blue-500{
  --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-teal-400{
  --tw-gradient-to: #2dd4bf var(--tw-gradient-to-position);
}
.bg-clip-text{
  background-clip: text;
}
.fill-blue-600{
  fill: #2563eb;
}
.fill-current{
  fill: currentColor;
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.p-1{
  padding: 0.25rem;
}
.p-10{
  padding: 2.5rem;
}
.p-2{
  padding: 0.5rem;
}
.p-4{
  padding: 1rem;
}
.p-6{
  padding: 1.5rem;
}
.px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-20{
  padding-left: 5rem;
  padding-right: 5rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[1rem\\]{
  padding-left: 1rem;
  padding-right: 1rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14{
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-28{
  padding-top: 7rem;
  padding-bottom: 7rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-16{
  padding-bottom: 4rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-\\[6rem\\]{
  padding-left: 6rem;
}
.pr-20{
  padding-right: 5rem;
}
.pt-10{
  padding-top: 2.5rem;
}
.pt-20{
  padding-top: 5rem;
}
.pt-24{
  padding-top: 6rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-\\[5rem\\]{
  padding-top: 5rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.font-primary{
  font-family: Montserrat;
}
.font-secondary{
  font-family: Roboto;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 1.415;
  letter-spacing: -0.017em;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 1.333;
  letter-spacing: -0.017em;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 1.277;
  letter-spacing: -0.017em;
}
.text-5xl{
  font-size: 2.75rem;
  line-height: 1.1;
  letter-spacing: -0.017em;
}
.text-\\[0\\.85rem\\]{
  font-size: 0.85rem;
}
.text-\\[0\\.8rem\\]{
  font-size: 0.8rem;
}
.text-\\[0\\.95rem\\]{
  font-size: 0.95rem;
}
.text-\\[1\\.25rem\\]{
  font-size: 1.25rem;
}
.text-\\[1\\.275rem\\]{
  font-size: 1.275rem;
}
.text-\\[1\\.75rem\\]{
  font-size: 1.75rem;
}
.text-\\[18px\\]{
  font-size: 18px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5;
  letter-spacing: -0.017em;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.5;
  letter-spacing: -0.017em;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.5715;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.5;
  letter-spacing: -0.017em;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1.5;
}
.font-\\[300\\]{
  font-weight: 300;
}
.font-\\[400\\]{
  font-weight: 400;
}
.font-\\[500\\]{
  font-weight: 500;
}
.font-\\[600\\]{
  font-weight: 600;
}
.font-\\[700\\]{
  font-weight: 700;
}
.font-bold{
  font-weight: 700;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.capitalize{
  text-transform: capitalize;
}
.italic{
  font-style: italic;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-tighter{
  letter-spacing: -0.05em;
}
.text-\\[\\#000\\]{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-\\[\\#4B0082\\]{
  --tw-text-opacity: 1;
  color: rgb(75 0 130 / var(--tw-text-opacity));
}
.text-\\[\\#808080\\]{
  --tw-text-opacity: 1;
  color: rgb(128 128 128 / var(--tw-text-opacity));
}
.text-\\[\\#888888\\]{
  --tw-text-opacity: 1;
  color: rgb(136 136 136 / var(--tw-text-opacity));
}
.text-\\[\\#D8BFD8\\]{
  --tw-text-opacity: 1;
  color: rgb(216 191 216 / var(--tw-text-opacity));
}
.text-\\[\\#FF0000\\]{
  --tw-text-opacity: 1;
  color: rgb(255 0 0 / var(--tw-text-opacity));
}
.text-\\[\\#fff\\]{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-\\[\\#ffff\\]{
  color: #ffff;
}
.text-\\[500\\]{
  color: 500;
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity));
}
.text-blue-800{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity));
}
.text-gray-200{
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity));
}
.text-primary{
  --tw-text-opacity: 1;
  color: rgb(0 141 218 / var(--tw-text-opacity));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}
.text-slate-50{
  --tw-text-opacity: 1;
  color: rgb(248 250 252 / var(--tw-text-opacity));
}
.text-transparent{
  color: transparent;
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.opacity-70{
  opacity: 0.7;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-box{
  --tw-shadow: rgba(0, 0, 0, 0.10) 0px 3px 6px, rgba(0, 0, 0, 0.16) 0px 3px 6px;;
  --tw-shadow-colored: 0px 3px 6px var(--tw-shadow-color), 0px 3px 6px; var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-box-2{
  --tw-shadow: rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 1px 1px;;
  --tw-shadow-colored: 0px 1px 1px var(--tw-shadow-color), 0px 0px 1px 1px; var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline{
  outline-style: solid;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur{
  --tw-backdrop-blur: blur(8px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[none\\]{
  --tw-backdrop-blur: blur(none);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-\\[200\\]{
  transition-duration: 200;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-linear{
  transition-timing-function: linear;
}

.sidebarStyle {
  display: inline-block;
  margin: 12px;
  background-color: #404040;
  color: #ffffff;
  z-index: 1 !important;
  padding: 6px;
  font-weight: bold;
}

.mapboxgl-popup {
  pointer-events: none
}

.marker2 {
  border:1px solid #fff;
  border: 1px solid blue;
  color: white;
  background: #3498db;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
 width: 20px;
 height: 20px;
  border-radius: 50%;
}


.spidered-marker .icon-div{
  position: relative;
  width: 25px;
  height: 41px;
  margin-left: -11.5px;
  margin-top: -38.5px;
  background-image: url(https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.0.0-beta.2/images/marker-icon.png);
}
.marker1 {
  background-color: #f28cb1;
  /* border: 1px solid blue;
  color: white;
  text-align: center;
  text-decoration: none;
  display: inline-block; */
  font-size: 16px;
 width: 20px;
 height: 20px;
  border-radius: 50%;
}


table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  padding: 8px;
  border-bottom: 1px solid #ddd;
  text-align: left;
}

th {
  background-color: #f2f2f2;
  font-weight: bold;
}

/* For Webkit (Safari, Chrome, etc.) */
::-webkit-scrollbar {
  width: 12px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* For Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loader {
  border-top-color: #3498db;
  border-left-color: #3498db;
  animation: spin 1s linear infinite;
}

.popup-content {
  width: auto !important;
  padding-left: 3rem !important;
  padding-right: 3rem !important;
}

.rmsc .dropdown-heading {
  height: auto !important;
  padding: 0.35rem 0.5rem !important;
  max-width: 11.5rem !important;
  overflow-x: auto;
}

.rmsc .dropdown-container {
  border: 1px solid #3498db4a !important;
}

.hero-card-1 {
  background: linear-gradient(to bottom right, #2980b9, #1abc9c);
 
}
.hero-card-2 {
  background: linear-gradient(to bottom, #0074d9, #4ea8de, #8acae7, #c4efff);
}
.hero-card-3 {
  background: linear-gradient(to bottom, #3498db, #9b59b6);
}
.hero-card-4 {
  background: linear-gradient(to bottom, #1abc9c, #3498db);
}

.hero-card-5 {
  background: linear-gradient(to bottom, #9b59b6, #1abc9c);
}

@keyframes clipAnimation {
  0%{ 
    clip-path: inset(0% 0 100% 0);
  }
  100% {
    clip-path: inset(0 0 0 0);
  }
}

.spider-leg-container {
  width: 1px;
  height: 1px;
  background:red;
  overflow: display;
  will-change: transform;
}

.spider-leg-container:hover { cursor: pointer }

.spider-leg-container .spider-leg-pin {
  position: relative;
  z-index: 1;
  transform: translate(-50%, -50%);
}

.spider-leg-container .spider-leg-pin.default-spider-pin{
  position: relative;
  width: 25px;
  height: 41px;
  margin-left: -11.5px;
  margin-top: -38.5px;
  background-image: url(https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.0.0-beta.2/images/marker-icon.png);
}

.spider-leg-container .spider-leg-line {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 2px;
  background-color: #343434;
  opacity: 0.45;
  transform-origin: bottom;
  z-index: 0;
  height: 0;
}

.spider-leg-container:hover .spider-leg-line { opacity: 1 }

/* Animations specific styles */

.spider-leg-container.animate {
  transition: margin 0.15s linear;
}

.spider-leg-container.initial,
.spider-leg-container.exit {
  margin-left: 0 !important;
  margin-top: 0 !important;
  height: 0;
}

.spider-leg-container.animate .spider-leg-line {
  transition: all 0.15s linear;
  transition-delay: inherit;
}

.spider-leg-container.animate.initial .spider-leg-line,
.spider-leg-container.animate.exit .spider-leg-line { height: 0 !important }

.rmsc .dropdown-heading {
  max-width: unset !important;
}

.dropdown-content {
  z-index:1000 !important;
}
.mapboxgl-popup {
  pointer-events: none !important;
}
.mapboxgl-popup-content {
  pointer-events: none !important;
}

.switch {
  display: inline-block;
  height: 34px;
  position: relative;
  width: 60px;
}

.switch input {
  display:none;
}

.slider {
  background-color: #ccc;
  bottom: 0;
  cursor: pointer;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transition: .4s;
}

.slider:before {
  background-color: #fff;
  bottom: 4px;
  content: "";
  height: 26px;
  left: 4px;
  position: absolute;
  transition: .4s;
  width: 26px;
}

input:checked + .slider {
  background-color: #66bb6a;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}


video {
  object-fit:cover;
}


.card:hover > .card-box > .card-item {
  opacity: 1;
  transition: all 500ms ease-in-out;
}


.before\\:absolute::before{
  content: var(--tw-content);
  position: absolute;
}


.before\\:bottom-0::before{
  content: var(--tw-content);
  bottom: 0px;
}


.before\\:bottom-2::before{
  content: var(--tw-content);
  bottom: 0.5rem;
}


.before\\:left-0::before{
  content: var(--tw-content);
  left: 0px;
}


.before\\:left-1\\/2::before{
  content: var(--tw-content);
  left: 50%;
}


.before\\:top-0::before{
  content: var(--tw-content);
  top: 0px;
}


.before\\:top-1\\/2::before{
  content: var(--tw-content);
  top: 50%;
}


.before\\:-z-2::before{
  content: var(--tw-content);
  z-index: -2;
}


.before\\:h-0::before{
  content: var(--tw-content);
  height: 0px;
}


.before\\:h-\\[0\\.15rem\\]::before{
  content: var(--tw-content);
  height: 0.15rem;
}


.before\\:h-\\[60vw\\]::before{
  content: var(--tw-content);
  height: 60vw;
}


.before\\:w-0::before{
  content: var(--tw-content);
  width: 0px;
}


.before\\:w-\\[60vw\\]::before{
  content: var(--tw-content);
  width: 60vw;
}


.before\\:w-full::before{
  content: var(--tw-content);
  width: 100%;
}


.before\\:-translate-x-1\\/2::before{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}


.before\\:-translate-y-1\\/2::before{
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}


.before\\:overflow-hidden::before{
  content: var(--tw-content);
  overflow: hidden;
}


.before\\:rounded-full::before{
  content: var(--tw-content);
  border-radius: 9999px;
}


.before\\:bg-\\[\\#000\\]::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}


.before\\:bg-\\[\\#fff\\]::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}


.before\\:bg-blue-200::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity));
}


.before\\:opacity-15::before{
  content: var(--tw-content);
  opacity: 0.15;
}


.before\\:transition-all::before{
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}


.before\\:duration-200::before{
  content: var(--tw-content);
  transition-duration: 200ms;
}


.before\\:ease-in-out::before{
  content: var(--tw-content);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}


.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}


.after\\:left-1\\/2::after{
  content: var(--tw-content);
  left: 50%;
}


.after\\:top-1\\/2::after{
  content: var(--tw-content);
  top: 50%;
}


.after\\:h-\\[70vw\\]::after{
  content: var(--tw-content);
  height: 70vw;
}


.after\\:w-\\[70vw\\]::after{
  content: var(--tw-content);
  width: 70vw;
}


.after\\:-translate-x-1\\/2::after{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}


.after\\:-translate-y-1\\/2::after{
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}


.after\\:rounded-full::after{
  content: var(--tw-content);
  border-radius: 9999px;
}


.after\\:bg-blue-200::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity));
}


.after\\:opacity-25::after{
  content: var(--tw-content);
  opacity: 0.25;
}


.hover\\:scale-105:hover{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}


.hover\\:scale-110:hover{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}


.hover\\:scale-\\[1\\.025\\]:hover{
  --tw-scale-x: 1.025;
  --tw-scale-y: 1.025;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}


.hover\\:scale-\\[1\\.2\\]:hover{
  --tw-scale-x: 1.2;
  --tw-scale-y: 1.2;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}


.hover\\:bg-\\[\\#c4c4c4\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(196 196 196 / var(--tw-bg-opacity));
}


.hover\\:bg-blue-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity));
}


.hover\\:bg-blue-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity));
}


.hover\\:bg-emerald-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(167 243 208 / var(--tw-bg-opacity));
}


.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}


.hover\\:bg-gray-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}


.hover\\:bg-gray-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}


.hover\\:bg-gray-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}


.hover\\:bg-orange-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 215 170 / var(--tw-bg-opacity));
}


.hover\\:bg-primary:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(0 141 218 / var(--tw-bg-opacity));
}


.hover\\:bg-slate-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity));
}


.hover\\:bg-slate-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity));
}


.hover\\:bg-slate-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity));
}


.hover\\:bg-opacity-40:hover{
  --tw-bg-opacity: 0.4;
}


.hover\\:font-\\[700\\]:hover{
  font-weight: 700;
}


.hover\\:text-\\[\\#000\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}


.hover\\:text-\\[\\#fff\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}


.hover\\:text-gray-700:hover{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}


.hover\\:text-gray-900:hover{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}


.hover\\:text-slate-50:hover{
  --tw-text-opacity: 1;
  color: rgb(248 250 252 / var(--tw-text-opacity));
}


.hover\\:shadow-xl:hover{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}


.hover\\:before\\:bottom-0:hover::before{
  content: var(--tw-content);
  bottom: 0px;
}


.hover\\:before\\:top-\\[unset\\]:hover::before{
  content: var(--tw-content);
  top: unset;
}


.hover\\:before\\:h-full:hover::before{
  content: var(--tw-content);
  height: 100%;
}


.hover\\:before\\:w-full:hover::before{
  content: var(--tw-content);
  width: 100%;
}


.focus\\:border-indigo-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity));
}


.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}


.focus\\:ring-indigo-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity));
}


.active\\:scale-95:active{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}


@media (min-width: 640px){

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.5715;
  }
}


@media (min-width: 768px){

  .md\\:relative{
    position: relative;
  }

  .md\\:sticky{
    position: sticky;
  }

  .md\\:right-5{
    right: 1.25rem;
  }

  .md\\:my-4{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .md\\:mb-0{
    margin-bottom: 0px;
  }

  .md\\:mb-12{
    margin-bottom: 3rem;
  }

  .md\\:mt-0{
    margin-top: 0px;
  }

  .md\\:mt-32{
    margin-top: 8rem;
  }

  .md\\:block{
    display: block;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:hidden{
    display: none;
  }

  .md\\:h-20{
    height: 5rem;
  }

  .md\\:h-\\[12rem\\]{
    height: 12rem;
  }

  .md\\:h-\\[20rem\\]{
    height: 20rem;
  }

  .md\\:h-\\[30rem\\]{
    height: 30rem;
  }

  .md\\:h-\\[4rem\\]{
    height: 4rem;
  }

  .md\\:h-\\[50vh\\]{
    height: 50vh;
  }

  .md\\:h-\\[5rem\\]{
    height: 5rem;
  }

  .md\\:h-\\[70vh\\]{
    height: 70vh;
  }

  .md\\:h-auto{
    height: auto;
  }

  .md\\:h-large{
    height: 30rem;
  }

  .md\\:max-h-\\[100\\%\\]{
    max-height: 100%;
  }

  .md\\:w-1\\/2{
    width: 50%;
  }

  .md\\:w-2\\/3{
    width: 66.666667%;
  }

  .md\\:w-\\[12rem\\]{
    width: 12rem;
  }

  .md\\:w-\\[25\\%\\]{
    width: 25%;
  }

  .md\\:w-\\[25rem\\]{
    width: 25rem;
  }

  .md\\:w-\\[30rem\\]{
    width: 30rem;
  }

  .md\\:w-\\[35\\.56rem\\]{
    width: 35.56rem;
  }

  .md\\:w-\\[40\\%\\]{
    width: 40%;
  }

  .md\\:w-\\[40rem\\]{
    width: 40rem;
  }

  .md\\:w-auto{
    width: auto;
  }

  .md\\:w-full{
    width: 100%;
  }

  .md\\:min-w-\\[20vw\\]{
    min-width: 20vw;
  }

  .md\\:min-w-\\[700px\\]{
    min-width: 700px;
  }

  .md\\:max-w-\\[100\\%\\]{
    max-width: 100%;
  }

  .md\\:max-w-\\[50\\%\\]{
    max-width: 50%;
  }

  .md\\:max-w-\\[90\\%\\]{
    max-width: 90%;
  }

  .md\\:max-w-\\[unset\\]{
    max-width: unset;
  }

  .md\\:grow{
    flex-grow: 1;
  }

  .md\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:flex-wrap{
    flex-wrap: wrap;
  }

  .md\\:items-center{
    align-items: center;
  }

  .md\\:justify-end{
    justify-content: flex-end;
  }

  .md\\:justify-between{
    justify-content: space-between;
  }

  .md\\:gap-4{
    gap: 1rem;
  }

  .md\\:gap-6{
    gap: 1.5rem;
  }

  .md\\:gap-8{
    gap: 2rem;
  }

  .md\\:overflow-auto{
    overflow: auto;
  }

  .md\\:overflow-hidden{
    overflow: hidden;
  }

  .md\\:overflow-x-hidden{
    overflow-x: hidden;
  }

  .md\\:bg-opacity-90{
    --tw-bg-opacity: 0.9;
  }

  .md\\:p-4{
    padding: 1rem;
  }

  .md\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }

  .md\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-12{
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .md\\:px-20{
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .md\\:px-28{
    padding-left: 7rem;
    padding-right: 7rem;
  }

  .md\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:py-0{
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .md\\:py-20{
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .md\\:py-52{
    padding-top: 13rem;
    padding-bottom: 13rem;
  }

  .md\\:pt-44{
    padding-top: 11rem;
  }

  .md\\:pt-8{
    padding-top: 2rem;
  }

  .md\\:text-2xl{
    font-size: 1.5rem;
    line-height: 1.415;
    letter-spacing: -0.017em;
  }

  .md\\:text-3xl{
    font-size: 1.875rem;
    line-height: 1.333;
    letter-spacing: -0.017em;
  }

  .md\\:text-4xl{
    font-size: 2.25rem;
    line-height: 1.277;
    letter-spacing: -0.017em;
  }

  .md\\:text-5xl{
    font-size: 2.75rem;
    line-height: 1.1;
    letter-spacing: -0.017em;
  }

  .md\\:text-6xl{
    font-size: 3.5rem;
    line-height: 1;
    letter-spacing: -0.017em;
  }

  .md\\:text-\\[1\\.125rem\\]{
    font-size: 1.125rem;
  }

  .md\\:text-\\[3rem\\]{
    font-size: 3rem;
  }

  .md\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.5;
    letter-spacing: -0.017em;
  }

  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.5715;
  }

  .md\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.5;
    letter-spacing: -0.017em;
  }

  .md\\:opacity-0{
    opacity: 0;
  }

  .md\\:backdrop-blur-sm{
    --tw-backdrop-blur: blur(4px);
    -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
            backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  }

  .md\\:before\\:h-\\[20rem\\]::before{
    content: var(--tw-content);
    height: 20rem;
  }

  .md\\:before\\:w-\\[20rem\\]::before{
    content: var(--tw-content);
    width: 20rem;
  }

  .md\\:after\\:h-\\[25rem\\]::after{
    content: var(--tw-content);
    height: 25rem;
  }

  .md\\:after\\:w-\\[25rem\\]::after{
    content: var(--tw-content);
    width: 25rem;
  }
}


@media (min-width: 1260px){

  .custom\\:absolute{
    position: absolute;
  }

  .custom\\:-top-4{
    top: -1rem;
  }

  .custom\\:left-\\[20\\%\\]{
    left: 20%;
  }

  .custom\\:mt-0{
    margin-top: 0px;
  }

  .custom\\:mt-10{
    margin-top: 2.5rem;
  }

  .custom\\:mt-20{
    margin-top: 5rem;
  }

  .custom\\:block{
    display: block;
  }

  .custom\\:flex{
    display: flex;
  }

  .custom\\:hidden{
    display: none;
  }

  .custom\\:w-\\[20rem\\]{
    width: 20rem;
  }

  .custom\\:w-\\[50\\%\\]{
    width: 50%;
  }

  .custom\\:max-w-\\[100\\%\\]{
    max-width: 100%;
  }

  .custom\\:max-w-\\[70\\%\\]{
    max-width: 70%;
  }

  .custom\\:max-w-\\[90\\%\\]{
    max-width: 90%;
  }

  .custom\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .custom\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .custom\\:flex-row{
    flex-direction: row;
  }

  .custom\\:items-start{
    align-items: flex-start;
  }

  .custom\\:items-center{
    align-items: center;
  }

  .custom\\:justify-between{
    justify-content: space-between;
  }

  .custom\\:px-20{
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .custom\\:py-32{
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .custom\\:text-left{
    text-align: left;
  }

  .custom\\:text-3xl{
    font-size: 1.875rem;
    line-height: 1.333;
    letter-spacing: -0.017em;
  }

  .custom\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.5;
    letter-spacing: -0.017em;
  }

  .custom\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.5;
    letter-spacing: -0.017em;
  }
}


@media (prefers-color-scheme: dark){

  .dark\\:bg-gray-500{
    --tw-bg-opacity: 1;
    background-color: rgb(107 114 128 / var(--tw-bg-opacity));
  }

  .dark\\:bg-gray-700{
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 81 / var(--tw-bg-opacity));
  }

  .dark\\:text-gray-400{
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity));
  }

  .dark\\:text-gray-600{
    --tw-text-opacity: 1;
    color: rgb(75 85 99 / var(--tw-text-opacity));
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAGA;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,gBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,sBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,mBAAc;EAAd,sBAAc;AAAA;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,iFAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,iBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,wCAAc;EAAd,4BAAc;EAAd,4BAAc;EAAd,qBAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,wBAAc;EAAd,sBAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,gBAAc;EAAd,UAAc;EAAd,iCAAc;UAAd,yBAAc;EAAd,qBAAc;EAAd,sBAAc;EAAd,6BAAc;EAAd,yBAAc;UAAd,iBAAc;EAAd,cAAc;EAAd,YAAc;EAAd,WAAc;EAAd,cAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,8BAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;AAAA;;AAAd;;EAAA;IAAA;EAAc;AAAA;;AAAd;EAAA,yDAAc;AAAA;;AAAd;;EAAA;IAAA;EAAc;AAAA;;AAAd;EAAA,yBAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,yBAAc;EAAd,8BAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,4BAAc;AAAA;;AAAd;;EAAA;IAAA;EAAc;AAAA;;AAAd;EAAA,yBAAc;EAAd;AAAc;;AAAd;EAAA,iBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,gBAAc;EAAd,UAAc;EAAd,gBAAc;EAAd;AAAc;;AAAd;EAAA,6BAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA,UAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,8EAAmB;EAAnB,4FAAmB;EAAnB;AAAmB;AAAnB;EAAA,sFAAmB;EAAnB,gGAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAGnB;EACE,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;CAChB,WAAW;CACX,YAAY;EACX,kBAAkB;AACpB;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,yGAAyG;AAC3G;AACA;EACE,yBAAyB;EACzB;;;;0BAIwB;EACxB,eAAe;CAChB,WAAW;CACX,YAAY;EACX,kBAAkB;AACpB;;;AAGA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,sCAAsC;AACtC;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,8DAA8D;;AAEhE;AACA;EACE,0EAA0E;AAC5E;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,wDAAwD;AAC1D;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,8BAA8B,gBAAgB;;AAE9C;EACE,kBAAkB;EAClB,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,yGAAyG;AAC3G;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,yBAAyB;EACzB,aAAa;EACb,wBAAwB;EACxB,UAAU;EACV,SAAS;AACX;;AAEA,+CAA+C,WAAW;;AAE1D,+BAA+B;;AAE/B;EAKE,+BAA+B;AACjC;;AAEA;;EAEE,yBAAyB;EACzB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EAKE,4BAA4B;EAM5B,yBAAyB;AAC3B;;AAEA;sDACsD,qBAAqB;;AAE3E;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE,gBAAgB;AAClB;;;AAGA;EACE,UAAU;EACV,iCAAiC;AACnC;;;AA/SA;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD,sBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD,sBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD,kBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD,kBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD,kBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD,wBA+SC;EA/SD,wDA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD,sBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD,sBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD,kBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,kBA+SC;EA/SD,kBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,iBA+SC;EA/SD,iBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,mBA+SC;EA/SD,mBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,iBA+SC;EA/SD,iBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,kBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,kBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,kBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,kBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,kBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,kBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,kBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,kBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,kBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,kBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,kBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,kBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,kBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA;AA+SC;;;AA/SD;EAAA;AA+SC;;;AA/SD;EAAA,oBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,oBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,oBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,oBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,oBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,gFA+SC;EA/SD,oGA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,0BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,sBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,8BA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,oBA+SC;EA/SD;AA+SC;;;AA/SD;EAAA,iBA+SC;EA/SD,iBA+SC;EA/SD;AA+SC;;;AA/SD;;EAAA;IAAA,oBA+SC;IA/SD;EA+SC;;EA/SD;IAAA,mBA+SC;IA/SD;EA+SC;AAAA;;;AA/SD;;EAAA;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA,gBA+SC;IA/SD;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA,iBA+SC;IA/SD;EA+SC;;EA/SD;IAAA,oBA+SC;IA/SD;EA+SC;;EA/SD;IAAA,kBA+SC;IA/SD;EA+SC;;EA/SD;IAAA,kBA+SC;IA/SD;EA+SC;;EA/SD;IAAA,kBA+SC;IA/SD;EA+SC;;EA/SD;IAAA,kBA+SC;IA/SD;EA+SC;;EA/SD;IAAA,kBA+SC;IA/SD;EA+SC;;EA/SD;IAAA,gBA+SC;IA/SD;EA+SC;;EA/SD;IAAA,iBA+SC;IA/SD;EA+SC;;EA/SD;IAAA,kBA+SC;IA/SD;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA,iBA+SC;IA/SD,kBA+SC;IA/SD;EA+SC;;EA/SD;IAAA,mBA+SC;IA/SD,kBA+SC;IA/SD;EA+SC;;EA/SD;IAAA,kBA+SC;IA/SD,kBA+SC;IA/SD;EA+SC;;EA/SD;IAAA,kBA+SC;IA/SD,gBA+SC;IA/SD;EA+SC;;EA/SD;IAAA,iBA+SC;IA/SD,cA+SC;IA/SD;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA,mBA+SC;IA/SD,gBA+SC;IA/SD;EA+SC;;EA/SD;IAAA,mBA+SC;IA/SD;EA+SC;;EA/SD;IAAA,kBA+SC;IA/SD,gBA+SC;IA/SD;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA,6BA+SC;IA/SD,+QA+SC;YA/SD;EA+SC;;EA/SD;IAAA,0BA+SC;IA/SD;EA+SC;;EA/SD;IAAA,0BA+SC;IA/SD;EA+SC;;EA/SD;IAAA,0BA+SC;IA/SD;EA+SC;;EA/SD;IAAA,0BA+SC;IA/SD;EA+SC;AAAA;;;AA/SD;;EAAA;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA,kBA+SC;IA/SD;EA+SC;;EA/SD;IAAA,iBA+SC;IA/SD;EA+SC;;EA/SD;IAAA;EA+SC;;EA/SD;IAAA,mBA+SC;IA/SD,kBA+SC;IA/SD;EA+SC;;EA/SD;IAAA,mBA+SC;IA/SD,gBA+SC;IA/SD;EA+SC;;EA/SD;IAAA,kBA+SC;IA/SD,gBA+SC;IA/SD;EA+SC;AAAA;;;AA/SD;;EAAA;IAAA,kBA+SC;IA/SD;EA+SC;;EA/SD;IAAA,kBA+SC;IA/SD;EA+SC;;EA/SD;IAAA,oBA+SC;IA/SD;EA+SC;;EA/SD;IAAA,oBA+SC;IA/SD;EA+SC;AAAA","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap\");\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n@import 'styles/utility-pattern.css';\n\n.sidebarStyle {\n  display: inline-block;\n  margin: 12px;\n  background-color: #404040;\n  color: #ffffff;\n  z-index: 1 !important;\n  padding: 6px;\n  font-weight: bold;\n}\n\n.mapboxgl-popup {\n  pointer-events: none\n}\n\n.marker2 {\n  border:1px solid #fff;\n  border: 1px solid blue;\n  color: white;\n  background: #3498db;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 16px;\n width: 20px;\n height: 20px;\n  border-radius: 50%;\n}\n\n\n.spidered-marker .icon-div{\n  position: relative;\n  width: 25px;\n  height: 41px;\n  margin-left: -11.5px;\n  margin-top: -38.5px;\n  background-image: url(https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.0.0-beta.2/images/marker-icon.png);\n}\n.marker1 {\n  background-color: #f28cb1;\n  /* border: 1px solid blue;\n  color: white;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block; */\n  font-size: 16px;\n width: 20px;\n height: 20px;\n  border-radius: 50%;\n}\n\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\nth,\ntd {\n  padding: 8px;\n  border-bottom: 1px solid #ddd;\n  text-align: left;\n}\n\nth {\n  background-color: #f2f2f2;\n  font-weight: bold;\n}\n\n/* For Webkit (Safari, Chrome, etc.) */\n::-webkit-scrollbar {\n  width: 12px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #888;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* For Firefox */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: #888 #f1f1f1;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.loader {\n  border-top-color: #3498db;\n  border-left-color: #3498db;\n  animation: spin 1s linear infinite;\n}\n\n.popup-content {\n  width: auto !important;\n  padding-left: 3rem !important;\n  padding-right: 3rem !important;\n}\n\n.rmsc .dropdown-heading {\n  height: auto !important;\n  padding: 0.35rem 0.5rem !important;\n  max-width: 11.5rem !important;\n  overflow-x: auto;\n}\n\n.rmsc .dropdown-container {\n  border: 1px solid #3498db4a !important;\n}\n\n.hero-card-1 {\n  background: linear-gradient(to bottom right, #2980b9, #1abc9c);\n \n}\n.hero-card-2 {\n  background: linear-gradient(to bottom, #0074d9, #4ea8de, #8acae7, #c4efff);\n}\n.hero-card-3 {\n  background: linear-gradient(to bottom, #3498db, #9b59b6);\n}\n.hero-card-4 {\n  background: linear-gradient(to bottom, #1abc9c, #3498db);\n}\n\n.hero-card-5 {\n  background: linear-gradient(to bottom, #9b59b6, #1abc9c);\n}\n\n@keyframes clipAnimation {\n  0%{ \n    clip-path: inset(0% 0 100% 0);\n  }\n  100% {\n    clip-path: inset(0 0 0 0);\n  }\n}\n\n.spider-leg-container {\n  width: 1px;\n  height: 1px;\n  background:red;\n  overflow: display;\n  will-change: transform;\n}\n\n.spider-leg-container:hover { cursor: pointer }\n\n.spider-leg-container .spider-leg-pin {\n  position: relative;\n  z-index: 1;\n  transform: translate(-50%, -50%);\n}\n\n.spider-leg-container .spider-leg-pin.default-spider-pin{\n  position: relative;\n  width: 25px;\n  height: 41px;\n  margin-left: -11.5px;\n  margin-top: -38.5px;\n  background-image: url(https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.0.0-beta.2/images/marker-icon.png);\n}\n\n.spider-leg-container .spider-leg-line {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 2px;\n  background-color: #343434;\n  opacity: 0.45;\n  transform-origin: bottom;\n  z-index: 0;\n  height: 0;\n}\n\n.spider-leg-container:hover .spider-leg-line { opacity: 1 }\n\n/* Animations specific styles */\n\n.spider-leg-container.animate {\n  -webkit-transition: margin 0.15s linear;\n  -moz-transition: margin 0.15s linear;\n  -ms-transition: margin 0.15s linear;\n  -o-transition: margin 0.15s linear;\n  transition: margin 0.15s linear;\n}\n\n.spider-leg-container.initial,\n.spider-leg-container.exit {\n  margin-left: 0 !important;\n  margin-top: 0 !important;\n  height: 0;\n}\n\n.spider-leg-container.animate .spider-leg-line {\n  -webkit-transition: all 0.15s linear;\n  -moz-transition: all 0.15s linear;\n  -ms-transition: all 0.15s linear;\n  -o-transition: all 0.15s linear;\n  transition: all 0.15s linear;\n\n  -webkit-transition-delay: inherit;\n  -moz-transition-delay: inherit;\n  -ms-transition-delay: inherit;\n  -o-transition-delay: inherit;\n  transition-delay: inherit;\n}\n\n.spider-leg-container.animate.initial .spider-leg-line,\n.spider-leg-container.animate.exit .spider-leg-line { height: 0 !important }\n\n.rmsc .dropdown-heading {\n  max-width: unset !important;\n}\n\n.dropdown-content {\n  z-index:1000 !important;\n}\n.mapboxgl-popup {\n  pointer-events: none !important;\n}\n.mapboxgl-popup-content {\n  pointer-events: none !important;\n}\n\n.switch {\n  display: inline-block;\n  height: 34px;\n  position: relative;\n  width: 60px;\n}\n\n.switch input {\n  display:none;\n}\n\n.slider {\n  background-color: #ccc;\n  bottom: 0;\n  cursor: pointer;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  transition: .4s;\n}\n\n.slider:before {\n  background-color: #fff;\n  bottom: 4px;\n  content: \"\";\n  height: 26px;\n  left: 4px;\n  position: absolute;\n  transition: .4s;\n  width: 26px;\n}\n\ninput:checked + .slider {\n  background-color: #66bb6a;\n}\n\ninput:checked + .slider:before {\n  transform: translateX(26px);\n}\n\n.slider.round {\n  border-radius: 34px;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}\n\n\nvideo {\n  object-fit:cover;\n}\n\n\n.card:hover > .card-box > .card-item {\n  opacity: 1;\n  transition: all 500ms ease-in-out;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
